/**
 * Page de gestion des patients
 */

import { useState } from 'react';
import { PatientList } from '../components/PatientList';
import { PatientForm } from '../components/PatientForm';

export function PatientsPage() {
  const [showForm, setShowForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSuccess = () => {
    setShowForm(false);
    setRefreshKey((k) => k + 1); // Force refresh
  };

  return (
    <div className="container-fluid">
      {showForm ? (
        <PatientForm onSuccess={handleSuccess} onCancel={() => setShowForm(false)} />
      ) : (
        <PatientList key={refreshKey} onCreateClick={() => setShowForm(true)} />
      )}
    </div>
  );
}
